/**
 * Demo Mode Manager
 * Handles demo mode toggle state and provides utilities for checking demo mode
 */

const DEMO_MODE_STORAGE_KEY = 'DEMO_MODE_OVERRIDE'

export class DemoModeManager {
  private static instance: DemoModeManager
  private demoModeOverride: boolean | null = null

  private constructor() {
    this.loadFromStorage()
  }

  static getInstance(): DemoModeManager {
    if (!DemoModeManager.instance) {
      DemoModeManager.instance = new DemoModeManager()
    }
    return DemoModeManager.instance
  }

  private loadFromStorage(): void {
    try {
      if (typeof window !== 'undefined') {
        const stored = localStorage.getItem(DEMO_MODE_STORAGE_KEY)
        this.demoModeOverride = stored ? JSON.parse(stored) : null
      }
    } catch (error) {
      console.error('Failed to load demo mode from storage:', error)
      this.demoModeOverride = null
    }
  }

  setDemoMode(enabled: boolean): void {
    this.demoModeOverride = enabled
    try {
      if (typeof window !== 'undefined') {
        localStorage.setItem(DEMO_MODE_STORAGE_KEY, JSON.stringify(enabled))
        console.log('🎭 Demo mode override set to:', enabled)
      }
    } catch (error) {
      console.error('Failed to save demo mode to storage:', error)
    }
  }

  clearDemoMode(): void {
    this.demoModeOverride = null
    try {
      if (typeof window !== 'undefined') {
        localStorage.removeItem(DEMO_MODE_STORAGE_KEY)
        console.log('🎭 Demo mode override cleared')
      }
    } catch (error) {
      console.error('Failed to clear demo mode from storage:', error)
    }
  }

  isDemoModeForced(): boolean {
    return this.demoModeOverride === true
  }

  isDemoModeDisabled(): boolean {
    return this.demoModeOverride === false
  }

  getDemoModeState(): 'forced' | 'disabled' | 'auto' {
    if (this.demoModeOverride === true) return 'forced'
    if (this.demoModeOverride === false) return 'disabled'
    return 'auto'
  }
}

export const demoModeManager = DemoModeManager.getInstance()
